// Helper function to convert decimal to fraction (rounded to 16ths)
export default function decimalToFraction(decimal) {
    if (decimal === null || decimal === undefined || decimal === 0) {
        return "0";
    }

    // Handle negative numbers
    const isNegative = decimal < 0;
    decimal = Math.abs(decimal);

    // Round to nearest 16th
    const sixteenths = Math.round(decimal * 16);
    const wholeNumber = Math.floor(sixteenths / 16);
    const remainder = sixteenths % 16;

    // If no fractional part, return just the whole number
    if (remainder === 0) {
        return isNegative ? `-${wholeNumber}` : `${wholeNumber}`;
    }

    // Simplify the fraction
    const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
    const commonDivisor = gcd(remainder, 16);
    const numerator = remainder / commonDivisor;
    const denominator = 16 / commonDivisor;

    // Format with dash if there's a whole number part
    let result;
    if (wholeNumber > 0) {
        result = `${wholeNumber}-${numerator}/${denominator}`;
    } else {
        result = `${numerator}/${denominator}`;
    }

    return isNegative ? `-${result}` : result;
}
